import type { Summary } from '@danfloss/views/SummaryView/useSummary';
import type { ISummaryData } from 'containers/AssemblyGroupStorage/types';

/**
 * Maps useSummary() hook output to ISummaryData for storage on backend.
 * ISummaryData is a serializable subset used for card display and PDF generation.
 */
export function extractSummaryData(s: Summary): ISummaryData {
  return {
    hose: s.hose
      ? { id: s.hose.id, title: s.hose.title, attributes: { image: s.hose.attributes?.image, description: s.hose.attributes?.description } }
      : undefined,
    fitting1: s.fitting1
      ? { id: s.fitting1.id, title: s.fitting1.title, attributes: { image: s.fitting1.attributes?.image, description: s.fitting1.attributes?.description } }
      : undefined,
    fitting2: s.fitting2
      ? { id: s.fitting2.id, title: s.fitting2.title, attributes: { image: s.fitting2.attributes?.image, description: s.fitting2.attributes?.description } }
      : undefined,
    accessories: s.accessories
      ? { id: s.accessories.id, title: s.accessories.title, attributes: { image: s.accessories.attributes?.image, description: s.accessories.attributes?.description } }
      : undefined,
    testing: s.testing
      ? { id: s.testing.id, title: s.testing.title, attributes: { image: s.testing.attributes?.image, description: s.testing.attributes?.description } }
      : undefined,
    lengthInInches: s.lengthInInches ?? 0,
    lengthInFeet: s.lengthInFeet ?? 0,
    lengthType: s.lengthType,
    angleOfRotation: s.angle,
    customerPartNumber: s.customerPartNumber ?? '',
    quantity: s.quantity,
    notes: s.notes,
    generatedConfigId: s.generatedConfigId ?? '',
  };
}
